export enum UserType {
  ADMIN = "ADMIN",
  ATTENDANT = "ATTENDANT",
  PARTNER = "PARTNER",
  BUSINESS = "BUSINESS",
  COLLABORATOR = "COLLABORATOR",
  BENEFICIARY = "BENEFICIARY",
}
